import { Box } from "@mui/material";
import { ReactNode } from "react";

interface DetailGridProps {
  children: ReactNode;
  columns?: number;
}

export default function DetailGrid({
  children,
  columns = 2,
}: DetailGridProps) {
  return (
    <Box
      component="dl"
      sx={{
        display: "grid",
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        rowGap: 1,
        columnGap: 1,
        margin: 0,
        padding: 0,
        alignItems: "center",
      }}
    >
      {children}
    </Box>
  );
}

